import React from 'react';
import { ProductId } from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { AppState } from 'services/types';
import ListItem from 'components/ListItem';
import {
    SprayEntityIds,
    SprayProduct,
    SprayApplicationRate
} from 'services/sprayEvents/types';
import { UnitTypeId } from 'services/unitTypes/types';
import { makeSelectProductTotal } from './selectors';

interface ConnectedProps {
    productTotal: string;
}

export interface OwnProps {
    productId: ProductId;
    entityIds: SprayEntityIds;
    product: SprayProduct;
    unitTypeId: UnitTypeId;
    applicationRate: SprayApplicationRate;
    needHalfCalculation: boolean;
}

export type Props = ConnectedProps & OwnProps;

export class ProductTotalListItemComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { productTotal } = this.props;

        return <ListItem value={productTotal} description="Product total" />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    productTotal: makeSelectProductTotal()
});

export default connect(mapStateToProps)(ProductTotalListItemComponent);
